<script lang="ts">
  // Keyboard help <dialog id="tik-keys"> (spec §17). The table is Arabic-only by design
  // (not localised in the legacy app) and reproduced verbatim.
  import { t } from '$lib/i18n';

  let { open = $bindable(false) }: { open?: boolean } = $props();

  let el = $state<HTMLDialogElement | null>(null);

  const ROWS: [string, string][] = [
    ['J / K', 'التنقل بين الرسائل'],
    ['Enter / O', 'فتح الرسالة'],
    ['U / Esc', 'الرجوع للقائمة'],
    ['J / K داخل الرسالة', 'الرسالة التالية · السابقة'],
    ['X', 'تحديد'],
    ['S', 'نجمة'],
    ['E', 'أرشفة'],
    ['M', 'كتم المحادثة'],
    ['B', 'تأجيل'],
    ['R / A / F', 'ردّ · ردّ على الكل · تمرير (داخل الرسالة)'],
    ['Shift+I / Shift+U', 'تعليم مقروءة · غير مقروءة'],
    ['#', 'حذف'],
    ['Z', 'تراجع'],
    ['C', 'رسالة جديدة'],
    ['/', 'بحث'],
    ['G ثم I / T / D / A / K', 'الوارد · المرسل · المسودات · الأرشيف · المهملات'],
    ['* ثم A / N / R / U / S', 'تحديد: الكل · لا شيء · المقروءة · غير المقروءة · المميَّزة'],
    ['Ctrl+Enter', 'إرسال (داخل الكتابة)'],
    ['Ctrl+Shift+C / B', 'إظهار نسخة · نسخة مخفية (داخل الكتابة)'],
    ['?', 'هذه اللوحة'],
  ];

  $effect(() => {
    const d = el;
    if (!d) return;
    if (open && !d.open) {
      if (typeof d.showModal === 'function') d.showModal();
      else d.setAttribute('open', '');
    } else if (!open && d.open) {
      if (typeof d.close === 'function') d.close();
      else d.removeAttribute('open');
    }
  });

  function onCancel(ev: Event) {
    ev.preventDefault();
    open = false;
  }
</script>

<dialog id="tik-keys" bind:this={el} oncancel={onCancel} onclose={() => (open = false)} aria-labelledby="tik-keys-title">
  <h3 id="tik-keys-title">{t('shortcuts')}</h3>
  <dl class="keys">
    {#each ROWS as [keys, desc] (keys)}
      <dt><kbd dir="ltr">{keys}</kbd></dt>
      <dd>{desc}</dd>
    {/each}
  </dl>
  <p class="hint">{t('shortcutsHint')}</p>
  <div class="dlg-actions">
    <button type="button" class="dlg-close" onclick={() => (open = false)}>{t('cancel')}</button>
  </div>
</dialog>

<style>
  /* @css shell/KeysDialog start */
  .dlg-actions {
    display: flex;
    gap: var(--space-2);
    justify-content: flex-end
  }

  #tik-keys::backdrop {
    background: var(--scrim)
  }

  #tik-keys {
    border: none;
    border-radius: var(--radius-panel);
    padding: var(--space-5);
    inline-size: min(460px, calc(100vw - var(--space-8)));
    background: var(--surface-card);
    color: var(--text-body);
    box-shadow: var(--shadow-dialog)
  }

  #tik-keys h3 {
    font-size: var(--text-lg);
    color: var(--text-strong);
    margin-bottom: var(--space-4)
  }

  .keys {
    display: grid;
    grid-template-columns: auto 1fr;
    gap: var(--space-2) var(--space-4);
    align-items: center;
    font-size: var(--text-sm)
  }

  .keys dt {
    justify-self: start
  }

  .keys dd {
    margin: 0;
    color: var(--text-muted)
  }

  kbd {
    display: inline-block;
    border: 1px solid var(--border-default);
    border-bottom-width: 2px;
    border-radius: var(--radius-xs);
    padding: var(--space-1) var(--space-2);
    font-family: inherit;
    font-size: var(--text-xs);
    color: var(--text-strong);
    background: var(--surface-subtle);
    white-space: nowrap
  }

  #tik-keys .hint {
    color: var(--text-faint);
    font-size: var(--text-xs);
    line-height: var(--leading-body);
    margin-top: var(--space-4)
  }

  .dlg-actions {
    display: flex;
    gap: var(--space-2);
    justify-content: flex-end
  }

  .dlg-close {
    min-height: 44px;
    padding-inline: var(--space-5);
    border-radius: var(--radius-control);
    font-weight: var(--weight-medium);
    color: var(--text-body)
  }

  .dlg-close:hover {
    background: var(--surface-subtle)
  }

  .dlg-close:active {
    background: var(--mail-pressed)
  }
  /* @css shell/KeysDialog end */
</style>
